var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpCircle = function SvgHelpCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Z",
    fill: "#001633"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.495 6.083v.004-.004ZM5.75 6l-.745-.083V5.91l.002-.01.004-.03.015-.096A4.085 4.085 0 0 1 5.47 4.51C5.87 3.79 6.647 3 8 3c1.166 0 1.993.374 2.485 1.064C10.941 4.701 11 5.466 11 6a2.687 2.687 0 0 1-1.75 2.53c-.17.065-.31.16-.398.257-.083.091-.102.161-.102.213v.25a.75.75 0 0 1-1.5 0V9c0-1.011.825-1.625 1.46-1.87.535-.206.79-.663.79-1.13 0-.466-.066-.826-.235-1.064C9.132 4.75 8.835 4.5 8 4.5c-.648 0-.995.335-1.22.74a2.588 2.588 0 0 0-.284.84l-.001.007a.75.75 0 0 1-1.49-.17L5.75 6ZM7 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
    fill: "#001633"
  })));
};
export default SvgHelpCircle;